import getConfig from 'next/config';

import {getApiRequest} from '~/src/utilities/feed/api';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

interface QueryParams {
    tenantId?: number;
    limit?: number;
}

export const fetchActivities = async (queryParams?: QueryParams) => {
    const options = {
        tenantId: config.tenantId,
        limit: 6,
        ...queryParams
    };

    const query = Object.entries(options)
        .filter(([key, value]) => value)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

    try {
        const {collection} = await getApiRequest(`${config.activity.service.activities}?${query}`);
        return collection;
    } catch (error) {
        Logger.info(`[${error.name}][helper/activities] Error while fetching activities`, {error});
    }

    return null;
};
